module.exports = __webpack_public_path__ + "static/media/appstore.7a04a385.png";